import { render, staticRenderFns } from "./RecoveryByEmail.vue?vue&type=template&id=1e1b5ab8&scoped=true&"
import script from "./RecoveryByEmail.vue?vue&type=script&lang=js&"
export * from "./RecoveryByEmail.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryByEmail.vue?vue&type=style&index=0&id=1e1b5ab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1b5ab8",
  null
  
)

export default component.exports